import React from 'react';

// Шапка мобильного каркаса по «Бумаге» (Newton — Мобильный.dc.html, экран
// «Новая запись»): слева кнопка шторки, по центру марка, справа остаток минут.
// Все три — белые плашки 44px: меньше палец не попадает (HANDOFF: тапы ≥ 44px).
export default function MobileHeader({ onMenu, quota, onQuota }) {
  return (
    <div className="shrink-0 flex items-center justify-between px-1 pt-[10px] pb-2 font-ui">
      <button
        type="button"
        onClick={onMenu}
        aria-label="Меню"
        data-testid="mobile-menu"
        className="w-11 h-11 rounded-[14px] bg-paper-card flex items-center justify-center"
      >
        <span className="w-[18px] flex flex-col gap-1">
          <span className="h-[2px] rounded-[1px] bg-paper-ink" />
          <span className="h-[2px] rounded-[1px] bg-paper-ink" />
          <span className="h-[2px] w-[60%] rounded-[1px] bg-paper-ink" />
        </span>
      </button>
      <span className="font-display font-extrabold text-[12px] tracking-[.08em] uppercase text-paper-ink">
        Бит.<span className="text-paper-accent">Ньютон</span>
      </span>
      {quota ? (
        <button
          type="button"
          onClick={onQuota}
          data-testid="mobile-quota"
          className={`h-11 px-3 rounded-[14px] bg-paper-card font-mono text-[12px]
                      ${quota.alarm ? 'text-paper-accent' : 'text-paper-ink'}`}
        >
          {quota.value}
        </button>
      ) : (
        // Пустое место той же ширины, что кнопка меню: иначе марка съезжает вправо.
        <span className="w-11" />
      )}
    </div>
  );
}
